/** Persistencia local de sesiones y mensajes del copiloto (ISSUE-05 F3). */

export const SESSIONS_KEY = "tagnize_copilot_sessions";
const MESSAGES_PREFIX = "tagnize_copilot_msgs_";
const ACTIVE_SESSION_KEY = "tagnize_copilot_active";
const SESSIONS_EVENT = "tagnize:copilot-sessions";

export const MAX_MESSAGES = 50;
export const MAX_BYTES = 500 * 1024;

export function notifySessionsUpdated() {
  window.dispatchEvent(new CustomEvent(SESSIONS_EVENT));
}

export function loadSessions() {
  try {
    return JSON.parse(localStorage.getItem(SESSIONS_KEY) || "{}");
  } catch {
    return {};
  }
}

export function saveSessionMeta(id, meta) {
  const all = loadSessions();
  all[id] = { ...all[id], ...meta, id, updatedAt: Date.now() };
  localStorage.setItem(SESSIONS_KEY, JSON.stringify(all));
  notifySessionsUpdated();
}

export function getActiveSessionId() {
  return localStorage.getItem(ACTIVE_SESSION_KEY) || "";
}

export function setActiveSessionId(id) {
  if (id) {
    localStorage.setItem(ACTIVE_SESSION_KEY, id);
  } else {
    localStorage.removeItem(ACTIVE_SESSION_KEY);
  }
}

function messagesKey(sessionId) {
  return `${MESSAGES_PREFIX}${sessionId}`;
}

function stripForStorage(messages) {
  return (messages || []).map((m) => ({
    role: m.role,
    content: m.content || "",
    renderSpec: m.renderSpec,
    tools: m.tools,
    usage: m.usage,
    fromCache: m.fromCache || false,
    createdAt: m.createdAt || Date.now(),
  }));
}

function truncateMessages(serialized) {
  let list = serialized.slice(-MAX_MESSAGES);
  let json = JSON.stringify(list);
  while (list.length > 1 && json.length > MAX_BYTES) {
    list = list.slice(1);
    json = JSON.stringify(list);
  }
  return { list, truncated: list.length < serialized.length || json.length >= MAX_BYTES };
}

export function loadSessionMessages(sessionId) {
  if (!sessionId) return [];
  try {
    const raw = localStorage.getItem(messagesKey(sessionId));
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveSessionMessages(sessionId, messages) {
  if (!sessionId) return;
  const serialized = stripForStorage(messages);
  const { list } = truncateMessages(serialized);
  localStorage.setItem(messagesKey(sessionId), JSON.stringify(list));
}

export function readInitialCopilotState(newSessionId) {
  const activeId = getActiveSessionId();
  const sessions = loadSessions();
  if (activeId && sessions[activeId]) {
    const meta = sessions[activeId];
    return {
      sessionId: activeId,
      messages: loadSessionMessages(activeId),
      sessionTokens: meta.sessionTokens || { input: 0, output: 0, cost: 0 },
      model: meta.model || "haiku",
    };
  }
  const id = newSessionId();
  return {
    sessionId: id,
    messages: [],
    sessionTokens: { input: 0, output: 0, cost: 0 },
    model: "haiku",
  };
}

export function subscribeSessionsUpdated(handler) {
  window.addEventListener(SESSIONS_EVENT, handler);
  return () => window.removeEventListener(SESSIONS_EVENT, handler);
}

/** Borra historial local del copiloto (sesiones, mensajes, sesión activa). */
export function clearCopilotClientData() {
  localStorage.removeItem(SESSIONS_KEY);
  localStorage.removeItem(ACTIVE_SESSION_KEY);
  for (let i = localStorage.length - 1; i >= 0; i -= 1) {
    const key = localStorage.key(i);
    if (key?.startsWith(MESSAGES_PREFIX)) {
      localStorage.removeItem(key);
    }
  }
  notifySessionsUpdated();
}
